import { memo } from 'react';
import { TournamentCardInfo } from './TournamentCardInfo';
import { TournamentCardImagery } from './TournamentCardImagery';
import { TournamentCardActions } from './TournamentCardActions';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import { TournamentContext } from 'src/contexts/docs/TournamentContext';
import { SideBar } from '../SideBar';
import { HoverProvider } from '../../../contexts/HoverContext';

export type TournamentCardProps = Tournament<Date>;

const TournamentCardUnmemoized: React.FC<TournamentCardProps> = (props) => {
  const theme = useTheme();

  return (
    <TournamentContext.Provider value={props}>
      <HoverProvider>
        <SideBar gradientColor={'primary.vertical'}>
          <Stack
            sx={{
              p: 1,
              background: theme.palette.background.elevation[10],
              borderRadius: '0px 10px 10px 0px',
            }}
          >
            <TournamentCardImagery />
            <TournamentCardInfo />
            <TournamentCardActions />
          </Stack>
        </SideBar>
      </HoverProvider>
    </TournamentContext.Provider>
  );
};

export const TournamentCard = memo(TournamentCardUnmemoized);
